"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateFnsLocales = exports.locales = exports.FORMATS = exports.LLLL = exports.LLLL_yyyy = exports.YYYY_MM_DD = exports.PPatp = exports.Patp = exports.PPp = exports.PPPpp = exports.PPP = exports.PP = exports.P = void 0;
/* eslint-disable @shinetools/shine/prefer-typographic-apostrophe */
const locale_1 = require("date-fns/locale");
const localized_strings_1 = __importDefault(require("localized-strings"));
// Examples: FR 12:00 | 12:00 AM
const p = 'p';
// [23/07/2021] [07/23/2021]
exports.P = 'P';
// [5 juil. 2021] [Jul 5, 2021]
exports.PP = 'PP';
// [5 juillet 2016] [July 5th, 2016]
exports.PPP = 'PPP';
// [5 juillet 2016 à 14:52:30] [July 5th, 2016 at 2:52:30 PM]
exports.PPPpp = 'PPPpp';
// [5 juillet 2016, 14:52] [Jul 5, 2016, 2:52 PM]
exports.PPp = 'PP, p';
// [17/05/2021 à 14:52] [05/17/2021 at 2:52 PM]
exports.Patp = 'Patp';
// [16 févr. 2022 à 10:35] [Feb 16, 2022 at 10:35 AM]
exports.PPatp = 'PPatp';
// [2021-05-17] [2021-05-17]
exports.YYYY_MM_DD = 'yyyy-MM-dd';
// [octobre 2021] [October 2021]
exports.LLLL_yyyy = 'LLLL yyyy';
// FR janvier, ... décembre | January, ..., December
exports.LLLL = 'LLLL';
// don’t forget to add your format to this map
exports.FORMATS = {
    LLLL: exports.LLLL,
    [exports.LLLL_yyyy]: exports.LLLL_yyyy,
    p,
    P: exports.P,
    Patp: exports.Patp,
    PP: exports.PP,
    PPatp: exports.PPatp,
    PPP: exports.PPP,
    [exports.PPp]: exports.PPp,
    PPPpp: exports.PPPpp,
    [exports.YYYY_MM_DD]: exports.YYYY_MM_DD,
};
/**
 * Custom format locales
 */
exports.locales = new localized_strings_1.default({
    en: {
        ...exports.FORMATS,
        [exports.Patp]: "P 'at' p",
        [exports.PPatp]: "PP 'at' p",
    },
    fr: {
        ...exports.FORMATS,
        [exports.Patp]: "P 'à' p",
        [exports.PPatp]: "PP 'à' p",
    },
});
/**
 * Date fns supported locales
 */
exports.dateFnsLocales = {
    en: locale_1.enUS,
    fr: locale_1.fr,
};
